export default "__VITE_ASSET__DHsTEjU7__"